import React from 'react';
import { Icon } from '@iconify/react';
import githubIcon from '@iconify-icons/simple-icons/github';
import linkedinIcon from '@iconify-icons/simple-icons/linkedin';
import mailIcon from '@iconify-icons/mdi/email';
import FloatingBlobBackground from './components/FloatingBlobBackground';
import NavWheel from './components/NavWheel';
import myImage from './assets/images/zohair.jpg';
import { Analytics } from '@vercel/analytics/react';

const SOCIALS = [
  { href: 'https://github.com/zoasif-coder', icon: githubIcon, label: 'GitHub' },
  { href: 'https://www.linkedin.com/in/zohair-asif-4b272593/', icon: linkedinIcon, label: 'LinkedIn' },
  { href: 'mailto:zohairasif@gmail.com', icon: mailIcon, label: 'Email' },
];

const LandingPage = () => {
  return (
    <div className="relative h-[100dvh] w-screen overflow-hidden bg-cream text-ink">
      {/* Fixed background — the wheel floats over it. */}
      <div className="pointer-events-none fixed inset-0 z-0">
        <FloatingBlobBackground />
      </div>

      {/* HEADER — name with photo underneath, top-left */}
      <header className="absolute left-6 top-6 z-20 sm:left-10 lg:left-16">
        <h1 className="font-bold uppercase leading-[0.82] tracking-tightest text-5xl sm:text-6xl lg:text-8xl">
          <span className="block">Zohair</span>
          <span className="block text-ink/30">[ Asif ]</span>
        </h1>
        <div className="mt-10 w-fit animate-float-slow sm:mt-12">
          <img
            src={myImage}
            alt="Zohair Asif"
            className="h-28 w-28 rounded-3xl border border-ink/15 object-cover shadow-soft-lg transition-all duration-500 hover:grayscale sm:h-32 sm:w-32 lg:h-40 lg:w-40"
          />
        </div>
      </header>

      <span className="absolute right-6 top-6 z-20 font-mono text-[10px] uppercase tracking-[0.3em] text-ink/40 sm:right-10 lg:right-16">
        ©{new Date().getFullYear()}
      </span>

      {/* WHEEL — vertically centred, centre-right/right on desktop */}
      <div className="absolute inset-y-0 right-0 z-10 flex w-full items-center justify-center pr-0 md:w-[56%] md:justify-center md:pr-2 lg:w-[58%] lg:pr-10">
        <NavWheel />
      </div>

      {/* FOOTER — socials + say hi */}
      <footer className="absolute inset-x-0 bottom-0 z-20 flex items-center justify-between gap-4 px-6 pb-6 sm:px-10 lg:px-16">
        <a
          href="mailto:zohairasif@gmail.com"
          className="font-bold uppercase leading-none tracking-tightest text-2xl underline-offset-8 hover:underline sm:text-3xl"
        >
          Say Hi
        </a>
        <div className="flex gap-3">
          {SOCIALS.map(({ href, icon, label }) => (
            <a
              key={label}
              href={href}
              target={href.startsWith('http') ? '_blank' : undefined}
              rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
              aria-label={label}
              className="flex h-10 w-10 items-center justify-center rounded-2xl border border-ink/15 bg-cream/60 text-ink shadow-soft backdrop-blur transition-colors duration-150 hover:bg-ink hover:text-cream"
            >
              <Icon icon={icon} width="20" height="20" />
            </a>
          ))}
        </div>
      </footer>

      <Analytics />
    </div>
  );
};

export default LandingPage;
